import React from 'react';
import Card from '../../../components/Card';
import SemesterLayout from '../../../components/SemesterLayout';

const Sem4 = ({ branch = "CSE" }) => {
  const notes = [
    { title: 'Circuits and Systems', link: `/notes/${branch.toLowerCase()}/CircuitsandSystems` },
    { title: 'Database Management System', link: `/notes/${branch.toLowerCase()}/DBMS` },
    { title: 'Programming in java', link: `/notes/${branch.toLowerCase()}/Java` },
    { title: 'Probability Statistics and Linear Programming', link: `/notes/${branch.toLowerCase()}/PSLP` },
    { title: 'Theory of Computation', link: `/notes/${branch.toLowerCase()}/Theory of Computation` },
    { title: 'Technical Writing', link: `/notes/${branch.toLowerCase()}/Technical Writing` }


  ];
  return (
    <SemesterLayout
      branch={branch}
      semester="4th Semester"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {notes.map((note, index) => (
          <Card key={index} title={note.title} link={note.link} />
        ))}
      </div>
    </SemesterLayout>
  );
};

export default Sem4;
